import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import type { ReactNode } from 'react';

export interface DashboardTableProps {
  children: ReactNode;
}

export function DashboardTable({ children }: DashboardTableProps) {
  return (
    <TableContainer sx={{ width: '100%', overflow: 'auto' }}>
      <Table
        className="table dashboard-table"
        size="small"
        stickyHeader
        sx={{
          '& .MuiTableCell-head': {
            fontWeight: 600,
            backgroundColor: 'action.hover',
            whiteSpace: 'nowrap',
          },
          '& .MuiTableCell-root': {
            borderTop: '1px solid',
            borderColor: 'divider',
          },
          '& .MuiTableHead-root .MuiTableCell-root': {
            borderTop: 'none',
          },
        }}
      >
        {children}
      </Table>
    </TableContainer>
  );
}
